import { searchTypes } from 'modules/search/constants/searchTypes';
import { SearchType } from 'modules/search/types/SearchType';

export function isSearchType(
  value: string | null | undefined,
): value is SearchType {
  return Boolean(value && (searchTypes as string[]).includes(value));
}
